import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const cvmodule = {
	state: {
		cv: '',
	},
	getters: {
		getCV: state => state.cv,
	},
	actions: {
		requestCV: ({ commit,dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.get('api/Alumno/dameCvUsuario').then(result => {
					if (result.data.status == 0) {
						commit('setCV', result.data.datos);
						resolve(true);
					} else {
						commit('setError', result.data.status);
						// dispatch('sendInfoAboutError',result.data);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		removeCV:({commit}) => {
			commit('eraseCV')
		},
		editProgramasInformaticos: ({ commit }, programas) => {
			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editInformatica`, programas).then(result => {
					if (result.data.status == 0) {
						commit('setProgramasInformaticos', programas);
						resolve(true);
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editImagenPerfil:({ commit }, data) => {
			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editImagenPerfil`, data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestUpdatePersonales:({commit,dispatch, getters}, data) => {

			let personales = getters.getCV.personales;

			for(let i in data){
				personales[i] = data[i];
			}

			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editDatosPersonales`, personales).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestUpdateInteres:({commit,dispatch, getters}, data) => {

			let interes = getters.getCV.interes;

			for(let i in data){
				interes[i] = data[i];
			}

			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editInteres`, interes).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addIdioma: ({ commit }, idioma) => {
			return new Promise((resolve, reject) => {
				axios.post().then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editIdioma: ({ commit,dispatch }, idioma) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editIdioma',idioma).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		eraseIdioma: ({ commit, dispatch }, idioma) => {
			let id = {id : idioma.id};
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/eliminaIdioma',id).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addDoc: ({ commit,dispatch }, doc) => {
			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/addDocumento`, doc).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true)
							commit('setError', 601);
						});
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addDoc2: ({ commit,dispatch }, doc) => {
			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/addDocumento2`, doc).then(result => {
					if (result.data.status == 0) {
						resolve(true)
						commit('setError', 618);
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		eraseDoc: ({ commit }, id) => {
			
			let data = {"id":id};

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/eliminaDocumento',data).then(result => {
					if (result.data.status == 0) {
						commit('eraseDoc', id);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		addExperiencia: ({ dispatch }, experiencia) => {

			let form = new FormData();

			form.append('jsonS', JSON.stringify(experiencia));

			return new Promise((resolve, reject) => {
				axios.post(`/ws/addExperiencia`, form).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editExperiencia: ({ dispatch, commit }, experiencia) => {

			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editExperiencia`, experiencia).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		eraseExperiencia: ({ commit,dispatch }, id) => {

			let data = {"id" : id};

			return new Promise((resolve, reject) => {
				axios.post(`/api/alumno/eliminaExperiencia`, data).then(result => {
					if (result.data.status == 0) {
						dispatch('requestCV').then(r => {
							resolve(true);
						})
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editProfesionalesGenerales: ({ commit }, data) => {
			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editDatosProfesionalesGenerales`,data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editAcademico: ({ commit }, estudio) => {

			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editEstudio`, estudio).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
        },	
        eraseAcademico: ({ commit }, id) => {

			let data = {
				"id" : id
			};

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/eliminaEstudio',data).then(result => {
					if (result.data.status == 0) {
						commit('eraseEstudio', id);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
        eraseOtroEstudio: ({ commit }, id) => {

			let data = {
				"id" : id
			};

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/eliminaOtroEstudio',data).then(result => {
					if (result.data.status == 0) {
						commit('eraseOtroEstudio', id);
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		editOtroEstudio: ({ commit }, estudio) => {

			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/editOtroEstudio`, estudio).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
        },	
		setEmailOfertas:({dispatch,commit}) => {
			return new Promise((resolve, reject) => {
				axios.post(`/api/Alumno/aceptaRecibirOfertas`).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestBasicosAlumno:({ commit,dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.get('api/Alumno/datosBasicosUsuario').then(result => {
					if (result.data.status == 0) {
						resolve(result.data.datos);
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		sendDireccion:({ commit,dispatch },data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/Alumno/editDatosDireccion',data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
						commit('setShowPopupDireccion',false)
						dispatch('requestCV');
					} else {
						commit('setError', result.data.status);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
	},
	mutations: {
		setCV(state, data) {
			state.cv = data;
		},
		eraseCV(state) {
			state.cv = ''
		},
		setProgramasInformaticos(state, programas){
			state.programasInformaticos = programas;
		},
		eraseIdioma(state, id) {
			state.cv.idiomas = state.cv.idiomas.filter(i => i.id != id)
		},
		editIdioma(state, idioma) {
			state.cv.idiomas.forEach(i => {
				(i.id == idioma.id) ? i = idioma : null;
			})
		},
		eraseDoc(state, id) {
			state.cv.documentos = state.cv.documentos.filter(i => i.id != id);
			if(state.cv.documentos.length == 0){
				state.cv.documentos = null;
			}
		},
		eraseExperiencia(state, id) {
			state.cv.profesional.experiencia = state.cv.profesional.experiencia.filter(i => i.id != id)
		},
		eraseEstudio(state, id) {
			state.cv.academicos = state.cv.academicos.filter(i => i.idTitulacion != id)
		},
		eraseOtroEstudio(state, id) {
			state.cv.otra_formacion = state.cv.otra_formacion.filter(i => i.id != id)
		}
		
	}
}

export default cvmodule;


// WEBPACK FOOTER //
// ./src/store/cvModule.js